<template>
  <div v-if="showImage" class="vehicle-image">
    <img class="vehicle-image__image" :src="imageUrl" />
    <div class="vehicle-image__caption" v-show="showCaption">
      Image used for illustrative purposes
    </div>
  </div>
</template>

<script lang="ts">
import {
  Component,
  Prop,
  Vue
} from 'vue-property-decorator';

import ImageType from '@/enums/ImageType';

import { imageUrlService } from '@/services/ImageUrlService';

@Component
export default class VehicleImageComponent extends Vue {
  @Prop({ default: false })
  public showCaption!: boolean;

  @Prop({ default: ImageType.Basic })
  public vehicleImageType!: number;

  @Prop({ default: 200 })
  public imageSize!: number;

  public get imageType(): string {
    return this.vehicleImageType === ImageType.Lifestyle ? 'lifestyle' : 'basic';
  }

  public get imageUrl(): string {
    return imageUrlService.imageUrl(
      this.vehicleImageType,
      this.imageSize
    );
  }

  public get showImage(): boolean {
    return this.imageUrl.length > 0;
  }
}
</script>
